import { createFileRoute } from '@tanstack/react-router'
import { WorkOrderPortal } from '../components/workorders/WorkOrderPortal'

// Public provider work-order portal (spec 2026-08-01-01 §7).
//
// It lives outside routes/$org, so it inherits no auth guard — which is the
// point: the reader is an external contractor with no account, holding a
// capability link mailed with an ordre de service. The token in the path is
// the entire authorization, and it unlocks exactly one intervention.
export const Route = createFileRoute('/wo/$orgCode/$token')({
    component: WorkOrderPortalRoute,
})

function WorkOrderPortalRoute() {
    const { orgCode, token } = Route.useParams()
    return <WorkOrderPortal orgCode={orgCode} token={token} />
}
